import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { timecode } from './SceneCard.js';
import type { Scene } from './storyboardResult.js';

export function SceneTable({ scenes }: { scenes: Scene[] }): ReactNode {
  return (
    <Box
      sx={{
        overflowX: 'auto',
        '& th, & td': {
          p: '12px',
          borderBottom: '1px solid',
          borderColor: 'divider',
          textAlign: 'left',
          verticalAlign: 'top',
          fontSize: 12,
          minWidth: 150,
        },
        '& th': { fontWeight: 600 },
        '& td': { whiteSpace: 'pre-wrap' },
      }}
    >
      <Box
        component="table"
        aria-label="Storyboard scenes"
        sx={{ width: '100%', borderCollapse: 'collapse', bgcolor: 'background.paper' }}
      >
        <thead>
          <tr>
            {['Scene', 'Visual', 'On-screen text', 'Voiceover', 'Audio', 'Call to action'].map(
              (label) => (
                <th key={label} scope="col">
                  {label}
                </th>
              ),
            )}
          </tr>
        </thead>
        <tbody>
          {scenes.map((scene) => (
            <tr key={`${scene.shot_label}-${scene.start_seconds}-${scene.visual}`}>
              <th scope="row">
                {scene.objective || scene.shot_label}
                <br />
                {timecode(scene)}
                <br />
                {[scene.framing, scene.camera_style].filter(Boolean).join(' · ')}
              </th>
              {(['visual', 'on_screen_text', 'voiceover', 'audio', 'cta'] as const).map((field) => (
                <td key={field}>{scene[field] || '—'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Box>
    </Box>
  );
}
